import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation endOfferMutation($input: UpdateOfferInput!) {
    updateOffer(input: $input) {
      offer {
        id
        endDate
        store {
          id
        }
      }
      errors {
        key
        messages
      }
    }
  }
`;

const endOffer = (environment, attributes, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: attributes,
    },
    optimisticResponse: {
      updateOffer: {
        offer: attributes,
      },
    },
    ...args,
  });
};

export default endOffer;
